import React, { useState, useEffect } from 'react';
import { Progress } from 'reactstrap';
import axios from 'axios';
import cookies from 'js-cookie';
// Utils
import { dataGenerator } from '../../utils';
// Assets
import uploadIcon from '../../assets/icons/upload-icon.png';
import pdfIcon from '../../assets/icons/pdficon.png';
// Styles
import './styles.scss';
import AlertAndConfirmation from '../../utils/AlertAndConfirmation';

const ImageUploader = props => {
  const [selectedFile, setSelectedFile] = useState();
  const [loaded, setLoaded] = useState(0);

  const handleFileUpload = event => {
    if (maxSelectFile(event) && checkMimeType(event) && checkFileSize(event)) {
      let formData = new FormData();
      let newMedias = [];
      let targetFiles = event.target.files;

      const filesArray = Array.from(event.target.files);

      let requestFileFieldName = props.isMulti ? 'files' : 'file';
      let requestFileKeyFieldName = props.isMulti ? 'filesKeys' : 'fileKey';

      for (let i = 0; i < filesArray.length; i++) {
        const file = filesArray[i];
        const fileKey = dataGenerator.generateKey('media');
        newMedias.push({
          key: fileKey,
          url: URL.createObjectURL(file),
          displayOrder: null,
        });
        formData.append(requestFileFieldName, file);
        formData.append(requestFileKeyFieldName, fileKey);
      }

      const config = {
        headers: {
          'Content-Type': 'multipart/form-data;',
          'auth-token': cookies.get('auth-token'),
        },
        onUploadProgress: ProgressEvent => {
          setLoaded((ProgressEvent.loaded / ProgressEvent.total) * 100);
        },
      };

      axios
        .post(props.actionUrl, formData, config)
        .then(res => {
          setSelectedFile(targetFiles);

          for (let i = 0; i < res.data.payload.uploadedFileNames.length; i++) {
            const { key, fileName } = res.data.payload.uploadedFileNames[i];
            const mediaIx = newMedias.findIndex(x => x.key === key);
            newMedias[mediaIx].fileName = fileName;
          }
          props.isMulti
            ? props.onUploadSuccess(newMedias)
            : props.onUploadSuccess(newMedias[0]);
          setLoaded(0);
        })
        .catch(err => {
          console.error('err', err);
          console.log('err', err.response?.data?.status);

          if (
            err.response?.data?.status === 'ERROR' ||
            err.response?.data?.status === 'FAIL'
          ) {
            AlertAndConfirmation({
              title: `خطا ${err.response.status}`,
              text: err.response?.data?.message,
              type: 'error',
              timer: 6000,
            });
          } else {
            AlertAndConfirmation({
              title: `خطا `,
              text: 'خطایی رخ داده است',
              type: 'error',
              timer: 6000,
            });
          }
          setLoaded(0);
        });
    }
  };

  const onDeleteMedia = key => {
    props.deleteImage(key);
  };

  const onDeleteSingleMedia = _ => {
    props.deleteImage();
  };

  const checkMimeType = event => {
    let files = event.target.files;

    let err = [];

    const types = ['image/png', 'image/jpeg', 'image/gif','image/webp', 'application/pdf'];

    for (var x = 0; x < files.length; x++) {
      if (types.every(type => files[x].type !== type)) {
        err[x] = `فرمت فایل ${files[x].type} پشتیبانی نمی‌شود\n`;
      }
    }

    for (var z = 0; z < err.length; z++) {
      event.target.value = null;
    }

    return err.length === 0;
  };

  const maxSelectFile = event => {
    let files = event.target.files;
    if (files.length > 3) {
      const msg = `حداکثر ۳ تصویر را می‌توان برای آپلود انتخاب کرد`;
      event.target.value = null;
      console.warn(msg);
      return false;
    }

    return true;
  };

  const checkFileSize = event => {
    let files = event.target.files;

    let size = 2000000;
    let err = [];

    for (var x = 0; x < files.length; x++) {
      if (files[x].size > size) {
        err[
          x
        ] = `حجم تصویر ${files[x].type} 'بیشتر از اندازه مجاز استُ لطفا فایل کم‌حجم‌تری انتخاب کنید\n'`;
      }
    }

    for (var z = 0; z < err.length; z++) {
      console.error(err[z]);
      event.target.value = null;
    }

    return err.length === 0;
  };

  const renderFiles = _ => {
    if (props.isMulti) {
      const images = props.imageFile.map(media => {
        let imageUrl;
        if (media.id) {
          imageUrl = `${ASSET_ENDPOINT}${media.url}`;
        } else {
          imageUrl = media.url;
        }

        return (
          <div className='upload-media' key={media.key}>
            <img src={imageUrl} className='img-thumb' />
            <div className='img-thumb-overlay'>
              <i
                className='fa fa-trash'
                onClick={e => onDeleteMedia(media.key)}
              ></i>
            </div>
          </div>
        );
      });
      return images;
    } else if (props.imageFile) {
      if (
        props.fileName?.slice(-3) === 'pdf' ||
        props.imageFile?.slice(-3) === 'pdf'
      ) {
        return (
          <div className='upload-media' key='1'>
            <img src={pdfIcon} className='img-thumb' />
            <div className='img-thumb-overlay'>
              <a href={props.imageFile} target='_blank' className='mx-2'>
                <i className='fa fa-eye'></i>
              </a>
              <i
                className='fa fa-trash'
                onClick={() => onDeleteSingleMedia()}
              ></i>
            </div>
          </div>
        );
      } else {
        return (
          <div className='upload-media' key='1'>
            <img src={props.imageFile} className='img-thumb' />
            <div className='img-thumb-overlay'>
              <i
                className='fa fa-trash'
                onClick={() => onDeleteSingleMedia()}
              ></i>
            </div>
          </div>
        );
      }
    }
  };

  return (
    <div className='rsee-img-uploader'>
      <label htmlFor={props.name} className='imageUploaderContainer'>
        {props.placeholder}
        {!selectedFile && <img src={uploadIcon} />}
        {!!loaded && (
          <Progress max='100' color='success' value={loaded}>
            {Math.round(loaded, 2)}%
          </Progress>
        )}
        {selectedFile &&
          [...selectedFile].map(file => (
            <img
              src={URL.createObjectURL(file)}
              alt={locales('file.uploaded')}
              style={{ width: '50px', height: '50px' }}
            />
          ))}
        <input
          type='file'
          name={props.name}
          id={props.name}
          onChange={handleFileUpload}
          multiple={props.isMulti}
          disabled={props.isDisabled || false}
          hidden
        />
      </label>
      <div className='upload-medias'>{renderFiles()}</div>
    </div>
  );
};

export default ImageUploader;
